import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../components/Login.vue'
import Home from '../views/Home.vue'
import ArchivoInput from '../views/ArchivoInput.vue'
import ArchivoOutput from '../views/ArchivoOutput.vue'
import NewInvoice from '../views/NewInvoice.vue'
import Reports from '../views/Reports.vue'
import InvoiceForm from '../components/InvoiceForm.vue'
import UserInfo from '../views/UserInfo.vue'
import PurchaseInvoice from '../components/PurchaseInvoice.vue'
//import config from '../../public/config.json'
import WelcomePage from '../views/WelcomePage.vue'
import Organization from '../views/Organization.vue'
import InvoiceNumber from '../views/InvoiceNumber.vue'
import ArchivoFeeOutput from '../views/ArchivoFeeOutput.vue'
import Users from '../views/Users.vue'
import UserOrganization from '../views/UserOrganization.vue'
import UserRole from '../views/UserRole.vue'
import UserItemCode from '../views/UserItemCode.vue'
import EditUser from '../views/EditUser.vue'
import IndividualVatRecord from '../views/IndividualVatRecord.vue'
import IndividualVatForm from '../views/IndividualVatForm.vue'
import OldIndividualVatForm from '../views/OldIndividualVatForm.vue'
import IndividualVatRecordExcel from '../views/IndividualVatRecordExcel.vue'
import GroupVatRecord from '../views/GroupVatRecord.vue'
import GroupVatForm from '../views/GroupVatForm.vue'
import OldGroupVatForm from '../views/OldGroupVatForm.vue'
import { i18n } from '../main'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', 
    name: 'Home',
    component: Home,
    props: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true,
    meta: {
      requiresVisitor: true
  }
  },
  {
    path: '/archivo/input',
    name: 'ArchivoInput',
    component: ArchivoInput,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/output',
    name: 'ArchivoOutput',
    component: ArchivoOutput,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/newinvoice',
    name: 'NewInvoice',
    component: NewInvoice,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/reports',
    name: 'Reports',
    component: Reports,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/createInvoice',
    name: 'InvoiceForm',
    component: InvoiceForm,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/purchaseInvoice',
    name: 'PurchaseInvoice',
    component: PurchaseInvoice,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/organization',
    name: 'Organization',
    component: Organization,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/invoiceNumber',
    name: 'InvoiceNumber',
    component: InvoiceNumber,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/welcomePage',
    name: 'WelcomePage',
    component: WelcomePage,
    props: true,
    meta: {
      requiresVisitor: true
    }   
  },
  {
    path: '/archivo/feeOutput',
    name: 'ArchivoFeeOutput',
    component: ArchivoFeeOutput,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/users',
    name: 'Users',
    component: Users,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/editUser',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/userOrganization',
    name: 'UserOrganization',
    component: UserOrganization,
    props: true,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/settings/userRole',
    name: 'UserRole',
    component: UserRole,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/userItemCode',
    name: 'UserItemCode',
    component: UserItemCode,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/individualVatRecord',
    name: 'IndividualVatRecord',
    component: IndividualVatRecord,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/individualVatForm',
    name: 'IndividualVatForm',
    component: IndividualVatForm,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/oldIndividualVatForm',
    name: 'OldIndividualVatForm',
    component: OldIndividualVatForm,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/uploadIndividualVatRecordExcel',
    name: 'IndividualVatRecordExcel',
    component:IndividualVatRecordExcel,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/groupVatRecord',
    name: 'GroupVatRecord',
    component: GroupVatRecord,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/groupVatForm',
    name: 'GroupVatForm',
    component: GroupVatForm,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/archivo/oldGroupVatForm',
    name: 'OldGroupVatForm',
    component: OldGroupVatForm,
    props: true,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  i18n.locale = localStorage.getItem('language') || 'srb'
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    if(localStorage.getItem('authType') == 'DB')
      next('/login')
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.isLoggedIn && localStorage.getItem('authType') == 'DB') {
      next('/')
    } 
    else {
      next()
    }
  }
  else  if (!store.getters.isLoggedIn) {
    if(localStorage.getItem('authType') == 'DB' && router.currentRoute.path != '/login'){
      next('/login')
    }
    else if(localStorage.getItem('welcomePage') == 'true' && router.currentRoute.path != '/welcomePage'){
      next ('/welcomePage')
    }
  }
  else {
    next()
  }
  
})

export default router
